/* eslint-disable no-magic-numbers */
export enum EProgressIndicatorType {
  TYPE0 = 0,
  TYPE1 = 1,
  TYPE2 = 2,
  TYPE3 = 3,
  TYPE4 = 4,
}
